import { getStaticPageSeoLinks } from "~~/shared/utils/seo/static-page";

export function useStaticPageSeo(pagePath: string): void {
  const { locale } = useI18n();
  const { SITE_URL } = usePublicUrls();

  useHead(() => ({
    link: getStaticPageSeoLinks(pagePath, locale.value, SITE_URL),
  }));
}
